export const SECTION_PROFILES = [
  { 
    id: 'hero',       
    primary: '#64ffda', 
    secondary: '#0fe3ff', 
    bg: '#0a0a0f', 
    pulseHz: 0.65, 
    linkCap: 1.8, 
    glow: 1.0, 
    bloom: 0.28, 
    dof: { focus: 7.5, aperture: 0.00024 } 
  },
  { 
    id: 'about',      
    primary: '#7b68ee', 
    secondary: '#a898ff', 
    bg: '#0a0a12', 
    pulseHz: 0.55, 
    linkCap: 1.6, 
    glow: 0.95, 
    bloom: 0.24, 
    dof: { focus: 7.2, aperture: 0.00022 } 
  },
  { 
    id: 'experience', 
    primary: '#ff6b9d', 
    secondary: '#ffd1e1', 
    bg: '#0f0a10', 
    pulseHz: 0.8,  
    linkCap: 1.7, 
    glow: 1.05, 
    bloom: 0.32, 
    dof: { focus: 7.8, aperture: 0.00026 } 
  },
  { 
    id: 'work',       
    primary: '#ffa500', 
    secondary: '#ffdc9a', 
    bg: '#100c0a', 
    pulseHz: 0.7,  
    linkCap: 1.9, 
    glow: 1.10, 
    bloom: 0.34, 
    dof: { focus: 7.6, aperture: 0.00025 } 
  },
  { 
    id: 'skills',     
    primary: '#00ff88', 
    secondary: '#b5ffde', 
    bg: '#0a100e', 
    pulseHz: 0.6,  
    linkCap: 1.7, 
    glow: 1.00, 
    bloom: 0.26, 
    dof: { focus: 7.4, aperture: 0.00023 } 
  },
  { 
    id: 'education',  
    primary: '#4169e1', 
    secondary: '#a9c4ff', 
    bg: '#0a0f12', 
    pulseHz: 0.5,  
    linkCap: 1.5, 
    glow: 0.95, 
    bloom: 0.22, 
    dof: { focus: 7.3, aperture: 0.00021 } 
  },
  { 
    id: 'contact',    
    primary: '#ff1493', 
    secondary: '#ff94cf', 
    bg: '#120a10', 
    pulseHz: 0.9,  
    linkCap: 2.0, 
    glow: 1.15, 
    bloom: 0.36, 
    dof: { focus: 8.0, aperture: 0.00028 } 
  }
];
